
export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Firm Assessment',
      description: 'We evaluate your intake, operations, and communication workflows.'
    },
    {
      number: '02',
      title: 'System Design',
      description: 'We architect AI systems aligned to your practice areas and firm standards.'
    },
    {
      number: '03',
      title: 'Secure Implementation',
      description: 'Systems are deployed with confidentiality, compliance, and stability as priorities.'
    },
    {
      number: '04',
      title: 'Optimization & Reporting',
      description: 'Ongoing refinement based on real performance data.'
    }
  ];

  return (
    <section id="process" className="bg-[#0E1A2B] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="font-serif text-4xl md:text-5xl text-[#F7F5F2] mb-6">
            A structured approach. Measurable results.
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="mb-6">
                <span className="text-6xl font-serif text-[#C8A14A] opacity-40">
                  {step.number}
                </span>
              </div>
              <h3 className="text-xl font-semibold text-[#F7F5F2] mb-4">
                {step.title}
              </h3>
              <p className="text-[#8A8F98] leading-relaxed text-sm">
                {step.description}
              </p>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-4 w-8 h-px bg-[#C8A14A] opacity-30"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
